import Tag from './../views/dashboard/components/general/Tag/tag'
import Branch from './../views/dashboard/components/general/Branch/branch'
import autocomplete from '../views/dashboard/components/general/patial/autocomplete'
import mSelect from '../views/dashboard/components/general/select/select.vue'
import mAutocomplete from '../views/dashboard/components/general/patial/mAutocomplete.vue'
import aicomplete from '../views/dashboard/components/general/AIcomplete/index'
import Confirm from '../views/dashboard/components/general/confirm/index.vue'
import Log from '../views/dashboard/pages/General/logDialog.vue'
import Notification from '../views/dashboard/components/general/notification/notification.vue'
import Printnew from '../views/dashboard/components/general/Print/IndexNew.vue'
import store from '@/store'
export default {
  data: () => ({
    panel: false,
    logoBrand: null,
    progressPercent: 0,
    excelPage: 1,
    excelLastPage: 1,
    tableHeight: 380,
    lockStatusItems: null,
    lockStatus: null,
    allRows: false,
    DB: null,
    personInfo: null,
    timerOfflineStore: 0,
    allYears: null,
    loadingDialog: false,
    branch: null,
    invoiceStoreResponse: null,
    colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1']
  }),
  computed: {
    isMobile() {
      if (this.$vuetify.breakpoint) {
        const breakpointName = this.$vuetify.breakpoint.name
        if (breakpointName === 'xs') {
          // console.log('xs')
        }
        return breakpointName === 'xs'
      } else {
        return false
      }
    },
    isTablet() {
      if (this.$vuetify.breakpoint) {
        const breakpointName = this.$vuetify.breakpoint.name
        if (breakpointName === 'sm') {
          // console.log('sm')
        }
        if (breakpointName === 'md') {
          // console.log('md')
        }
        return breakpointName === 'sm' || breakpointName === 'md'
      } else {
        return false
      }
    },
    documentPermmission() {
      if (this.$store.state.userCurrentPlan != null) {
        const docSystem = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'documentsSystem')
        if (docSystem && docSystem.value == 'active') {
          if (this.$store.state.permissions && this.$store.state.permissions.includes('documents')) {
            return true
          }
        } else {
          return false
        }
      }
      /* var disable = true
      if (this.$store.state.allConfig && this.$store.state.allConfig.documentsSystem === 'active') {
        disable = false
      }
      if (!disable && this.$store.state.permissions && this.$store.state.permissions.includes('documents')) {
        disable = false
      } else {
        disable = true
      }
      return disable */
    },
    investorPermmission() {
      var disable = true
      if (this.$store.state.allConfig && this.$store.state.allConfig.investorSystem === 'active') {
        disable = false
      }
      if (!disable && this.$store.state.permissions && this.$store.state.permissions.includes('investors')) {
        disable = false
      } else {
        disable = true
      }
      return disable
    },
    lockPermission() {
      /* var active = false
      if (this.$store.state.allConfig && this.$store.state.allConfig.lockSystem === 'active') {
        active = true
      }
      if (active && this.$store.state.permissions && this.$store.state.permissions.includes('lockDocuments')) {
        active = true
      } else {
        active = false
      }
      return active */

      if (this.$store.state.userCurrentPlan != null) {
        const lockItem = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'lockSystem')
        if (lockItem && lockItem.value == 'active') {
          if (this.$store.state.permissions && this.$store.state.permissions.includes('lockDocuments')) {
            return true
          }
        } else {
          return false
        }
      }
    },

    hasCustomerClub() {
      if (this.$store.state.userCurrentPlan != null) {
        const hasCustomerClub = this.$store.state.userCurrentPlan.has_customer_club;
        return hasCustomerClub
      }
    },
    dobarePermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const dobare = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'dobareSystem')
        if (dobare && dobare.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    magnetPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const magnet = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'magnetSystem')
        if (magnet && magnet.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    afraPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const afra = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'afraSystem')
        if (afra && afra.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    baSalamPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const basalam = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'basalamIntegrator')
        if (basalam && basalam.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    sazitoPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const sazito = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'sazitoIntegrator')
        if (sazito && sazito.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    portalPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const portal = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'portalIntegrator')
        if (portal && portal.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    woocommercePermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const woo = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'woocommerceIntegrator')
        if (woo && woo.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    webziPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const webzi = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'webziIntegrator')
        if (webzi && webzi.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    digikalaPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const digi = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'digikalaIntegrator')
        if (digi && digi.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    mixinPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const mixin = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'mixinIntegrator')
        if (mixin && mixin.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    snapshopPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const snap = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'snapShopIntegrator')
        if (snap && snap.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    markitoPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const markito = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'markitoIntegrator')
        if (markito && markito.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    webhookPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const webhook = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'web_service')
        if (webhook && webhook.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    commissionPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const commision = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'commissionSystem')
        if (commision && commision.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    investorPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const investor = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'integratorSystem')
        if (investor && investor.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    translationPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const translate = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'translationSystem')
        if (translate && translate.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    learningPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const learning = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'learningSystem')
        if (learning && learning.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    restaurantPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const restaurant = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'restaurantSystem')
        if (restaurant && restaurant.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    salaryPermission() {
      if (this.$store.state.userCurrentPlan != null) {
        const salaryOption = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'salarySystem')
        if (salaryOption && salaryOption.value == 'active') {
          return true
        } else {
          return false
        }
      }
    },
    customFieldsPermission() {
      var active = false
      if (this.$store.state.allConfig && this.$store.state.allConfig.customFieldsSystem === 'active') {
        active = true
      }
      return active
    },
    countWoocommercePanel() {
      var active = false
      if (this.$store.state.allConfig && this.$store.state.allConfig.customFieldsSystem === 'active') {
        active = true
      }
      return active
    },
    taxPayerSystem() {
      if (this.$store.state.userCurrentPlan != null) {
        const taxSystem = this.$store.state.userCurrentPlan.plan.options.find(item => item.key == 'taxPayerSystem')
        if (taxSystem && taxSystem.value == 'active') {
          if (this.$store.state.userCurrentPlan.has_taxpayer) {
            return true
          }
        } else {
          return false
        }
      }
      /*
      var status = false
      if (this.$store.state.allConfig && this.$store.state.allConfig.taxPayerSystem === 'active') {
        status = true
      }
      return status */
    }
  },
  beforeMount() {
    this.logoBrand = '/logo/' + this.$brand + '.png'
    this.DBCheck()
  },
  // watch: {
  //   '$store.state.allConfig': {
  //     deep: true,
  //     handler (newVal) {
  // clearTimeout(this.timerOfflineStore)
  // var app = this
  // this.timerOfflineStore = setTimeout(function () {
  //
  //   // app.createInvoiceOffline()
  // }, 1000)
  //     },
  //   },
  // },
  components: {
    aicomplete,
    Notification,
    mAutocomplete,
    autocomplete,
    Branch,
    mSelect,
    Printnew,
    Log,
    Confirm,
    Tag
  },
  mounted() {
    this.onResize()
    // var app = this
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
    if (this.currency && this.options) {
      this.options = {
        locale: 'en-US',
        prefix: '',
        suffix: this.currency.name,
        precision: this.currency.decimal
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  beforeRouteLeave(to, from, next) {
    if (!this.allRows) {
      next()
    }
  },
  methods: {
    checkAgTableValidation(columnDefs, rowData, gridApi, invalidCellsMap) {
      const invalidCells = this.getInvalidRowsAndCols(columnDefs, rowData)

      if (invalidCells.length) {
        invalidCells.forEach(cell => {
          if (!invalidCellsMap[cell.rowId]) invalidCellsMap[cell.rowId] = {}
          invalidCellsMap[cell.rowId][cell.colId] = true

          const rowNode = gridApi.getRowNode(cell.rowId)
          gridApi.flashCells({
            rowNodes: [rowNode],
            columns: [cell.colId],
            flashDelay: 2000
          })

          gridApi.refreshCells({
            rowNodes: [rowNode],
            columns: [cell.colId],
            force: true
          })
        })

        this.snakbarText = this.$t('decleared items are reqiured')
        this.snakbarColor = 'red'
        this.snakbar = true
        this.snakbarTimeOut = 2000

        return false
      } else {
        this.invalidCellsMap = {}
        if (gridApi) {
          gridApi.refreshCells({ force: true })
          gridApi.redrawRows()
        }
        return true
      }
    },
    getInvalidRowsAndCols(columnDefs, rowData) {
      const colsWithRule = columnDefs?.filter(col => {
        if (typeof col.cellEditorParams === 'function') {
          const params = col.cellEditorParams({ node: { id: 0 } })
          return params.rules && params.rules.length
        }
        return col.cellEditorParams?.rules && col.cellEditorParams.rules.length
      })
      const invalidCells = []
      rowData.forEach((row, rowIndex) => {
        colsWithRule.forEach(col => {
          let rules = null
          if (typeof col.cellEditorParams === 'function') {
            const params = col.cellEditorParams({ node: { id: row.id } })
            rules = params.rules
          } else {
            rules = col.cellEditorParams?.rules
          }

          if (rules && rules.length) {
            const value = row[col.field]
            const hasError = rules.some(rule => rule(value) !== true)
            if (hasError) {
              invalidCells.push({ rowId: row.id, colId: col.field })
            }
          }
        })
      })
      /* console.log('Invalid cells with row id:', invalidCells) */
      return invalidCells
    },
    $numberFormat(x, type = 'currency', currencyDecimal = 10) {
      if (isNaN(x)) {
        return 0
      }
      if (x === null || x === undefined) {
        return 0
      }
      x = parseFloat(x)
      var decimal = 0
      if (Math.floor(x.valueOf()) === x.valueOf()) {
        decimal = 0
      } else {
        decimal = x ? x.toString().split('.')[1].length || 0 : ''
      }
      if (type === 'currency' && store && store.state && store.state.currency) {
        if (currencyDecimal !== 10) {
          x = x.toFixed(currencyDecimal).replace(/\.0+$/, '')
        } else {
          decimal = (store.state.currency && store.state.currency.decimal !== null ? store.state.currency.decimal : 0)
          if (this.currency && this.currency.decimal) {
            decimal = this.currency.decimal
          }
          x = x.toFixed((decimal < 4 ? decimal : 4)).replace(/\.0+$/, '')
        }
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    toFixedWithoutZeros(num, precision) {
      return num.toFixed(precision).replace(/\.0+$/, '')
    },
    focusInputChecker() {
    },
    DBCheck() {
      if (this.$route && this.$route.matched[0] && this.$route.matched[0].path === '/mDash') {
        this.DB = new window.JsStore.Connection()
      }
    },
    setDefaultCooki() {
      var offline = (this.getCookie('offlineInvoice') !== null ? this.getCookie('offlineInvoice') : null)
      if (offline) {
        if (offline === 'true') {
          this.offline = true
        } else {
          this.offline = false
        }
      }
    },
    setCookie(name, value) {
      window.document.cookie = name + '=' + value
    },
    getCookie(name) {
      var cookie = null
      if (name) {
        var items = window.document.cookie
        items = items.split('; ')
        items.map(function (value) {
          var item = value.split('=')
          if (item[0] === name) {
            cookie = item[1]
          }
        })
      }
      return cookie
    },
    modifyVuetifyApplication() {
      // var app = this
      // setTimeout(function () {
      //   if (app.$vuetify.rtl) {
      //     app.$vuetify.application.right = 55
      //   } else {
      //     app.$vuetify.application.left = 55
      //   }
      // }, 50)
    },
    removePermission(type) {
      if (this.$store.state.permissions) {
        if (type === 'cost') {
          return this.$store.state.permissions.includes('removeCost')
        }
        if (type === 'income') {
          return this.$store.state.permissions.includes('removeIncome')
        }
        if (type === 'pay') {
          return this.$store.state.permissions.includes('removePayTreasury')
        }
        if (type === 'recieve') {
          return this.$store.state.permissions.includes('removeReceiveTreasury')
        }
        if (type === 'production') {
          return this.$store.state.permissions.includes('removeProduction')
        }
        if (type === 'bundling') {
          return this.$store.state.permissions.includes('removeBundling')
        }
        if (type === 'formula') {
          return this.$store.state.permissions.includes('removeFormula')
        }
        if (type === 'tempReceipt') {
          return this.$store.state.permissions.includes('removeTempReceipt')
        }
        if (type === 'receipt') {
          return this.$store.state.permissions.includes('removeReceiptEntrepot')
        }
        if (type === 'receipt') {
          return this.$store.state.permissions.includes('removeReceiptEntrepot')
        }
        if (type === 'remittance') {
          return this.$store.state.permissions.includes('removeRemittance')
        }
        if (type === 'useRemittance') {
          return this.$store.state.permissions.includes('removeUseRemittance')
        }
        if (type === 'transferRemittance') {
          return this.$store.state.permissions.includes('removeTransferRemittance')
        }
        if (type === 'warehouseHandling') {
          return this.$store.state.permissions.includes('removeWarehouseHandling')
        }
        if (type === 'account') {
          return this.$store.state.permissions.includes('removeAccount')
        }
        if (type === 'details') {
          return this.$store.state.permissions.includes('removeDetails')
        }
        if (type === 'product') {
          return this.$store.state.permissions.includes('removeProduct')
        }
        if (type === 'service') {
          return this.$store.state.permissions.includes('removeService')
        }
        if (type === 'payCheck') {
          return this.$store.state.permissions.includes('removePayCheck')
        }
        if (type === 'recieveCheck') {
          return this.$store.state.permissions.includes('removeRecieveCheck')
        }
        if (type === 'purchase') {
          return this.$store.state.permissions.includes('removePurchase')
        }
        if (type === 'presale') {
          return this.$store.state.permissions.includes('removePresale')
        }
        if (type === 'sell') {
          return this.$store.state.permissions.includes('removeSell')
        }
        if (type === 'returnPurchase') {
          return this.$store.state.permissions.includes('removeReturnPurchase')
        }
        if (type === 'returnSell') {
          return this.$store.state.permissions.includes('removeReturnSell')
        }
        if (type === 'bank') {
          return this.$store.state.permissions.includes('removeBank')
        }
        if (type === 'cash') {
          return this.$store.state.permissions.includes('removeCash')
        }
        if (type === 'branches') {
          /* return this.$store.state.permissions.includes('removeBranch') */
          return true
        }
        if (type === 'subCategory') {
          /* return this.$store.state.permissions.includes('removeSubCategory') */
          return true
        }
        if (type === 'category') {
          /* return this.$store.state.permissions.includes('removeSubCategory') */
          return true
        }
        if (type === 'group') {
          /* return this.$store.state.permissions.includes('removeSubCategory') */
          return true
        }
      }
    },
    feeValidate(value) {
      if (!value || parseFloat(value) <= 0) {
        return this.$t('is-required')
      } else {
        return true
      }
    },
    onResize() {
      this.tableHeight = (this.isMobile ? window.innerHeight - 245 : window.innerHeight - 245)
    },
    focusEvent: function (event) {
      const el = event.target
      setTimeout(() => {
        el.select()
      }, 10)
    },
    rnd(a, b) {
      return Math.floor((b - a + 1) * Math.random()) + a
    },
    randomColor() {
      return '#' + (Math.random() * 0xFFFFFF << 0).toString(16)
    },
    remainAccountSms(item) {
      var app = this
      app.loading = true
      app.$axios.get(this.$endpoint + 'customer/show', {
        params: {
          remainSms: 'active',
          id: item.id
        }
      })
        .then(res => {
          res = res.data
          app.snakbarColor = 'green'
          app.snakbarText = app.$t('sent')
          app.snakbar = true
        })
        .catch(err => {
          var error = err.response
          if (error.status === 401) {
            this.$router.push({ name: 'logout' })
          }
        })
        .finally(() => (app.loading = false))
    },
    setInitCurrency() {
      this.currency = this.$store.state.currency
      this.currency_amount = this.$store.state.currency.amount
    },
    getPermissions() {
      var app = this
      app.$axios.get(app.$endpoint + 'getdetail', {
        params: {
          select: 'getPermissions'
        }
      })
        .then(res => {
          res = res.data
          app.$store.commit('SET_PERMISSIONS', res.permissions)
          // if (app.$route.name !== 'Dashboard' && res.permissions.findIndex(x => x === app.$route.name) === -1) {
          //   app.$router.push({ path: '/403?back=-1' })
          // }
          app.$store.commit('SET_STUDENTLABEL', (res.config.studentLabel ? res.config.studentLabel : app.$t('studentLabel')))
          app.$store.commit('SET_IRANSANSENNUM', res.config.iranSansEnNum)
          /*     app.$store.commit('SET_PORTAL', res.config.portManagement)
          app.$store.commit('SET_SAZITO', res.config.sazito)
          app.$store.commit('SET_BASALAM', res.config.basalam)
          app.$store.commit('SET_WEBZI', res.config.webzi) */
          app.$store.commit('SET_GATEWAY', res.config.gateway)
          app.$store.commit('SET_ONLINEINVOICE', res.config.onlineInvoice)
          app.$store.commit('SET_ABSENTSMS', res.config.academyAbsentSms)
          /*  app.$store.commit('SET_WOOCOMMERCE', res.config.wooManagement)
          app.$store.commit('SET_DIGIKALA', res.config.digikalaManagement)
          app.$store.commit('SET_MARKITO', res.config.markitoManagement)
          app.$store.commit('SET_WEBHOOK', res.config.webhook) */
          app.$store.commit('SET_TRANSLATIONSYSTEM', res.config.translationSystem)
          app.$store.commit('SET_LEARNINGSYSTEM', res.config.learningSystem)
          app.$store.commit('SET_SHOPSYSTEM', res.config.shopSystem)
          app.$store.commit('SET_RANK', res.rank)
          app.$store.commit('SET_MENU', res.mn)
          app.$store.commit('SET_ADMIN', res.adm)
          app.$store.commit('SET_TOPMENU', res.tmn)
          app.$store.commit('SET_ACCESSTYPE', res.acs)
          app.$store.commit('SET_CUID', res.cuid)
          localStorage.setItem('cuid', res.cuid)
          app.$store.commit('SET_ALLCONFIG', res.config)
          app.items = res.mn
          app.checkBookmark()
          var abr = JSON.parse(localStorage.getItem('token'))
          document.title = abr.init.abrName + ' - ' + app.$t('abriron')
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.isLoading = false))
    },
    checkBookmark() {
      var app = this
      app.items.map(function (value, key) {
        if (value.children) {
          value.hide = true
          value.children.map(function (val, key) {
            if (val.to === 'divider') {
              value.hide = false
              val.hide = false
            } else if (app.$store.state.permissions.findIndex(x => x === val.to) !== -1) {
              if (app.$store.state.menuBookmark) {
                if (app.$store.state.menuBookmark.findIndex(x => x.value === val.to) !== -1) {
                  val.bookmark = true
                }
              }
              value.hide = false
              val.hide = false
            } else {
              val.hide = true
            }
          })
        }
      })
    },
    createShortcut(item) {
      var app = this
      var formData = new FormData()
      formData.append('title', this.$t(item.title))
      formData.append('to', item.to)
      formData.append('icon', item.icon)
      formData.append('color', app.randomColor())
      app.$axios.post(this.$endpoint + 'shortcut', formData)
        .then(res => {
          app.$store.commit('SET_SHORTCUT_ITEMS', item)
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (this.isLoading = false))
    },
    AI_Host_Name() {
      if (location.host === 'abr.abriron.com') {
        return 'https://src.abriron.com'
      } else {
        return 'http://localhost:8080'
      }
    },
    goToLink(to) {
      console.log(to)
      this.$router.push({ path: to })
    },
    async generateExcellForAllData(data, total) {
      var app = this
      app.creatExcelData(data, 'all')
      app.excelPage++

      if (total >= app.excelPage) {
        await app.getItems()
      } else {
        app.$refs.refExcel.generate()
        app.excelPage = 1
        app.allRows = false
        setTimeout(function () {
          app.creatExcelData(app.items, 'page')
        }, 1000)
      }
    },
    getAllRows() {
      this.allRows = true
      this.excelItems = []
      this.getItems()
    },
    isRequiredMessage(text) {
      return this.$t('field') + ' ' + text + ' ' + this.$t('isRequired')
    },
    paginate(array, pageSize, pageNumber) {
      return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)
    },
    getAllProductsOffline(type) {
      var isDB = localStorage.getItem('dbCreated')
      if (isDB) {
        this.DBCreate()
      }
      if (isDB && isDB === 'active') {
        this.loading = true
        this.loadingDialog = true
        var app = this
        var connection = new window.JsStore.Connection()
        connection.openDb('db_' + this.$store.state.userId)
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'getAllProductOffline',
            formType: type,
            page: app.excelPage
          }
        })
          .then(res => {
            res = res.data
            app.excelLastPage = res.last_page || 1
            if (app.excelPage === 1) {
              connection.clear('products')
            }
            app.progressPercent = (app.excelPage / app.excelLastPage) * 100
            connection.insert({ into: 'products', upsert: true, values: res.data })
            if (app.excelLastPage > app.excelPage) {
              app.excelPage++
              app.getAllProductsOffline('sell')
            } else {
              app.getAllProductsBarcodesOffline()
            }
            // localStorage.setItem('products', JSON.stringify(res))
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.disabled = false
            if (app.items && app.items.length === 0) {
              app.showAlert = true
              if (app.selectByBarcode) {
                setTimeout(function () {
                  app.search = null
                }, 1500)
              }
            }
            app.loading = false
          })
      }
    },
    getAllProductsBarcodesOffline(type) {
      var isDB = localStorage.getItem('dbCreated')
      if (isDB) {
        this.DBCreate()
      }
      if (isDB && isDB === 'active') {
        this.loading = true
        this.loadingDialog = true
        var app = this
        var connection = new window.JsStore.Connection()
        connection.openDb('db_' + this.$store.state.userId)
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'getAllProductBarcodesOffline',
            formType: type,
            page: app.excelPage
          }
        })
          .then(res => {
            res = res.data
            // app.excelLastPage = res.last_page || 1
            if (app.excelPage === 1) {
              connection.clear('productBarcodes')
            }
            app.progressPercent = (app.excelPage / app.excelLastPage) * 100
            connection.insert({ into: 'productBarcodes', upsert: true, values: res })
            if (app.excelLastPage > app.excelPage) {
              app.excelPage++
              // app.getAllProductsOffline('sell')
              app.getAllProductsBarcodesOffline()
            } else {
              app.getAllProductIntegratorOffline()
            }
            // localStorage.setItem('products', JSON.stringify(res))
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.disabled = false
            if (app.items && app.items.length === 0) {
              app.showAlert = true
              if (app.selectByBarcode) {
                setTimeout(function () {
                  app.search = null
                }, 1500)
              }
            }
            app.loading = false
          })
      }
    },
    getAllProductIntegratorOffline() {
      var isDB = localStorage.getItem('dbCreated')
      if (isDB) {
        this.DBCreate()
      }
      if (isDB && isDB === 'active') {
        this.loading = true
        this.loadingDialog = true
        var app = this
        var connection = new window.JsStore.Connection()
        connection.openDb('db_' + this.$store.state.userId)
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'productIntegrator',
            count: 100000
          }
        })
          .then(res => {
            res = res.data
            connection.clear('productIntegrator')
            connection.insert({ into: 'productIntegrator', upsert: true, values: res.data })
            app.getAllProductShortcutOffline()
            // localStorage.setItem('products', JSON.stringify(res))
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.disabled = false
            if (app.items && app.items.length === 0) {
              app.showAlert = true
              if (app.selectByBarcode) {
                setTimeout(function () {
                  app.search = null
                }, 1500)
              }
            }
            app.loading = false
          })
      }
    },
    getAllProductShortcutOffline() {
      var isDB = localStorage.getItem('dbCreated')
      if (isDB) {
        this.DBCreate()
      }
      if (isDB && isDB === 'active') {
        this.loading = true
        this.loadingDialog = true
        var app = this
        var connection = new window.JsStore.Connection()
        connection.openDb('db_' + this.$store.state.userId)
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'productShortcut',
            count: 100000
          }
        })
          .then(res => {
            res = res.data
            connection.clear('productShortcut')
            connection.insert({ into: 'productShortcut', upsert: true, values: res })
            app.getAllProductShortcutItemsOffline()
            // localStorage.setItem('products', JSON.stringify(res))
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.disabled = false
            if (app.items && app.items.length === 0) {
              app.showAlert = true
              if (app.selectByBarcode) {
                setTimeout(function () {
                  app.search = null
                }, 1500)
              }
            }
            app.loading = false
          })
      }
    },
    getAllProductShortcutItemsOffline() {
      var isDB = localStorage.getItem('dbCreated')
      if (isDB) {
        this.DBCreate()
      }
      if (isDB && isDB === 'active') {
        this.loading = true
        this.loadingDialog = true
        var app = this
        var connection = new window.JsStore.Connection()
        connection.openDb('db_' + this.$store.state.userId)
        app.$axios.get(app.$endpoint + 'getdetail', {
          params: {
            select: 'productShortcutItems',
            count: 100000
          }
        })
          .then(res => {
            res = res.data
            connection.clear('productShortcutItems')
            if (res && res.length > 0) {
              connection.insert({ into: 'productShortcutItems', upsert: true, values: res })
            }
            app.$store.commit('SET_RELOADSHORTCUT', true)
            // localStorage.setItem('products', JSON.stringify(res))
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(function () {
            app.disabled = false
            app.loading = false
            app.loadingDialog = false
          })
      }
    },
    async DBCreate() {
      var isDB = localStorage.getItem('dbCreated')
      if (!isDB) {
        var userId = this.$store.state.userId
        const dbName = 'db_' + userId
        const isExisting = (await window.indexedDB.databases()).map(db => db.name).includes(dbName)
        this.DB = new window.JsStore.Connection()
        var connection = this.DB
        var invoice = {
          name: 'invoice',
          columns: {
            id: { dataType: 'number' },
            accountId: { dataType: 'number' },
            date: { dataType: 'string' },
            type: { dataType: 'string' },
            ouid: { dataType: 'string' },
            store: { dataType: 'boolean' }
          }
        }
        var products = {
          name: 'products',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
            barcode: { dataType: 'string' },
            code: { dataType: 'string' },
            group_id: { dataType: 'number' },
            count: { dataType: 'number' }
          }
        }
        var person = {
          name: 'person',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' },
            mobile: { dataType: 'string' },
            phone: { dataType: 'string' },
            address: { dataType: 'string' },
            remain: { dataType: 'number' }
          }
        }
        var entrepot = {
          name: 'entrepot',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' }
          }
        }
        var branch = {
          name: 'branch',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' }
          }
        }
        var currency = {
          name: 'currency',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' }
          }
        }
        var productGroup = {
          name: 'productGroup',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' }
          }
        }
        var productIntegrator = {
          name: 'productIntegrator',
          columns: {
            id: { dataType: 'number' },
            product_id: { dataType: 'number' },
            value: { dataType: 'string' }
          }
        }
        var productShortcut = {
          name: 'productShortcut',
          columns: {
            id: { dataType: 'number' },
            name: { dataType: 'string' }
          }
        }
        var productShortcutItems = {
          name: 'productShortcutItems',
          columns: {
            id: { dataType: 'number' },
            page_id: { dataType: 'number' }
          }
        }
        var productBarcodes = {
          name: 'productBarcodes',
          columns: {
            product_id: { dataType: 'number' },
            value: { dataType: 'string' }
          }
        }
        var db = {
          name: 'db_' + userId,
          tables: [products, productBarcodes, person, entrepot, branch, productGroup, currency, invoice, productIntegrator, productShortcut, productShortcutItems],
          version: 1
        }
        if (isExisting) {
          localStorage.setItem('dbCreated', 'active')
        }
        var isDbCreated = await connection.initDb(db)
        if (isDbCreated) {
          localStorage.setItem('dbCreated', 'active')
          location.reload()
        }
      }
    },
    getAllPersonOffline() {
      this.loading = true
      var app = this
      app.$axios.get(app.$endpoint + 'getdetail', {
        params: {
          select: 'getAllPersonOffline'
        }
      })
        .then(res => {
          res = res.data
          localStorage.setItem('person', JSON.stringify(res))
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(function () {
          app.disabled = false
          if (app.items && app.items.length === 0) {
            app.showAlert = true
            if (app.selectByBarcode) {
              setTimeout(function () {
                app.search = null
              }, 1500)
            }
          }
          app.loading = false
        })
    },
    getAbrOffline() {
      this.loading = true
      var app = this
      app.$axios.get(app.$endpoint + 'getdetail', {
        params: {
          select: 'getAbrOffline'
        }
      })
        .then(res => {
          res = res.data
          localStorage.setItem('abr', JSON.stringify(res))
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(function () {
          app.loading = false
        })
    },
    getPersonInfo(id) {
      var app = this
      var type = 'getPersonInfo'
      app.$axios.get(app.$endpoint + 'getdetail?select=' + type + '&id=' + id)
        .then(res => {
          res = res.data
          app.personInfo = res
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => (app.isLoading = false))
    },
    createInvoiceOffline() {
      var app = this
      var connection = app.DB
      connection.openDb('db_' + this.$store.state.userId)
      connection.select({
        from: 'invoice',
        where: {
          type: {
            in: ['sell', 'returnSell']
          },
          store: true
        }
      }).then(function (data) {
        data.map(async function (value, index) {
          setTimeout(function () {
            app.invoiceStore(value)
          }, index * 10000)
        })
      })
    },
    async invoiceStore(value) {
      var app = this
      if (value.id) {
        return app.$axios.put(app.$endpoint + 'invoice/' + value.uid, value)
          .then(res => {
            res = res.data
            var connection = app.DB
            connection.openDb('db_' + app.$store.state.userId)
            connection.update({
              in: 'invoice',
              set: {
                store: false,
                id: res.data.id
              },
              where: {
                ouid: value.ouid
              }
            })
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        return app.$axios.post(app.$endpoint + 'invoice', value)
          .then(res => {
            res = res.data
            var connection = app.DB
            connection.openDb('db_' + app.$store.state.userId)
            connection.update({
              in: 'invoice',
              set: {
                store: false,
                id: res.data.id
              },
              where: {
                ouid: value.ouid
              }
            })
          })
          .finally(() => {
          })
      }
    },
    copied() {
      this.snakbarText = this.$t('copied')
      this.snakbarColor = 'blue'
      this.snakbar = true
    },
    roundDown(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces)
      return Math.floor(num * factor) / factor
    },
    roundUp(num, decimalPlaces) {
      const factor = Math.pow(10, decimalPlaces)
      return Math.ceil(num * factor) / factor
    },
    roundMath(number, decimals) {
      const factor = Math.pow(10, decimals)
      return Math.round(number * factor) / factor
    },
    sendPriceToPOS(item, amount) {
      var app = this
      app.loading = true
      app.isLoading = true
      app.$axios.get(this.$endpoint + 'invoice', {
        params: {
          pos: 'active',
          posData: item,
          amount: amount
        }
      })
        .then(res => {
          res = res.data
          if (res.IsSuccess) {
            app.snakbarColor = 'green'
            app.snakbarText = app.$t('paymentIsSuccessful')
          } else {
            app.snakbarColor = 'pink'
            app.snakbarText = res.ErrorDescription
            app.showClearing = true
            app.clearingStatus = null
            app.bank = null
          }
          app.snakbar = true
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(function () {
          app.isLoading = false
          app.loading = false
        })
    },
    async leavePage(to, from, next) {
      const confirmLeave = await this.$refs.confirm.open(
        'Confirm',
        this.$t('doYouSureLeavePage?')
      )

      if (confirmLeave) {
        next() // اجازه ناوبری
      } else {
        next(false) // لغو ناوبری
      }
    },
    async getInvoice(uid) {
      var app = this
      this.$store.commit('SET_INVOICEDATA', null)
      app.$axios.get(this.$endpoint + 'invoice/' + uid + '/edit', {
        params: {
          id: uid
        }
      })
        .then(res => {
          res = res.data
          app.$store.commit('SET_INVOICEDATA', res)
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
    },
    autoPrintInvoice(data) {
      var body = data.body
      var html = '<!DOCTYPE html><html><meta charset="utf-8"><head>' +
        '<style scoped>' +
        '  thead > tr > td{border: solid 1px #171717;padding: 5px;font-size: 12px}' +
        '  tbody > tr > td{border: solid 1px #171717;padding: 5px;font-size: 12px}' +
        '  tfoot > tr > td{border: solid 1px #171717;padding: 5px;font-size: 12px}' +
        '  body{font-family: "B Nazanin";}}' +
        '@page {' +
        '    padding: 0mm;' +
        '    margin: 0mm;' +
        ' }' +
        ' @media print {' +
        '    margin: 0mm; padding: 0mm' +
        '}' +
        '</style>' +
        '</head>' +
        '<body style="width:100;direction: rtl">' + body +
        '</body>' +
        '</html>'
      const socket = new WebSocket('ws://localhost:4022/Print')
      socket.onopen = function (event) {
        socket.send(html)
      }
    },
    createGoogleCalendarLink(eventDetails) {
      const {
        startDate, // فرمت: YYYYMMDDTHHmmss
        endDate, // فرمت: YYYYMMDDTHHmmss
        summary, // عنوان رویداد
        location, // مکان
        description // توضیحات
      } = eventDetails

      // ساخت لینک
      const url = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(summary)}&details=${encodeURIComponent(description)}&location=${encodeURIComponent(location)}&dates=${startDate}/${endDate}`

      // ایجاد لینک HTML
      const link = document.createElement('a')
      link.href = url
      link.textContent = 'Add to Google Calendar'
      link.target = '_blank' // باز کردن در تب جدید
    },
    deleteDatabase() {
      var userId = this.$store.state.userId
      var name = 'db_' + userId
      indexedDB.deleteDatabase(name)
      localStorage.removeItem('dbCreated')
    }
  }
}
